import { fullSingleLineAddress, HasAddress } from "@sp-crm/core";
import {
    EntityDetails,
    hasEntityDetails,
    labeledContactPhones,
    present,
} from "components/details-page-v-next/entity-contact-details";

export interface HomeCareLeadContactSource extends HasAddress {
    name?: string | null;
    cellPhone?: string | null;
    phone1?: string | null;
    email1?: string | null;
    email1OptOut: boolean;
}

export interface HomeCareLeadDetailsSource {
    selfContactEntity: HomeCareLeadContactSource;
    bestContactEntity: HomeCareLeadContactSource;
}

export const homeCareLeadContactDetails = (
    contact: HomeCareLeadContactSource,
): EntityDetails => ({
    classification: null,
    classificationLabel: "Role",
    phones: labeledContactPhones({
        cell: contact.cellPhone,
        alternate: contact.phone1,
    }),
    fax: null,
    email: present(contact.email1),
    emailOptOut: contact.email1OptOut,
    address: present(fullSingleLineAddress(contact)),
    website: null,
    organization: null,
});

export const hasHomeCareLeadDetails = (lead: HomeCareLeadDetailsSource): boolean =>
    !!present(lead.selfContactEntity.name) ||
    !!present(lead.bestContactEntity.name) ||
    hasEntityDetails(homeCareLeadContactDetails(lead.selfContactEntity)) ||
    hasEntityDetails(homeCareLeadContactDetails(lead.bestContactEntity));
